export const ELocaleCode = {
	EN_US: 'en-US',
	RU_RU: 'ru-RU',
} as const;
